// Design system scripted functionality.
require('@babel/polyfill');
require('./lib/ajax-form');
require('./lib/animate-group.js');
require('./lib/content-selector');
require('./lib/form-envoy.js');
require('./lib/form-hint');
require('./lib/list-editor');
require('./lib/marketo-form-mobile');
require('./lib/nav-menu-app');
require('./lib/nav-tab-scroll');
require('./lib/florida-state');
require('./lib/homeBuyingSteps');
require('./lib/why-title-genius');
require('./lib/elp-side-panel');
require('./lib/site-menu-collapse.js');
require('./lib/skip-navigation');
require('./lib/snap');
require('./lib/state-map');
require('./lib/warn-msie-win10.js');
require('./lib/warn-msie-win7.js');
require('./lib/hpi/hpi-index.js');
require('./lib/splitEdge.js');

(($) => {
    $('[data-toggle="tooltip"]').tooltip();
    $('.animation-group').animateGroup();
    $('.form-envoy').formEnvoy();
    $('.form-hint[data-toggle!="tooltip"]').formHint();
    $('form').listEditor();
    $('.nav-tabs .nav-link').navTabScroll();
    //$('form[data-ajax]').ajaxForm();
    $('.site-menu.collapse').siteMenuCollapse();
    $('.skip-nav').skipNavigation();
    $('.snap-container').snap();
    $('.state-map').stateMap({select: '#state-selector'});
    $('.msie-win7-warning-modal').warnMSIEWin7();
    $('.msie-win10-warning-modal').warnMSIEWin10();
})(jQuery);
